import React, { Suspense } from "react";
import { mapContentToBlock } from "../../utils/mapContentToBlock";
import { OptimizelyContentArea } from "../../types/optimizely/base";

interface ContentAreaProps {
  contentArea: OptimizelyContentArea;
  isFrontPage?: boolean;
}

export const ContentArea: React.FC<ContentAreaProps> = ({ contentArea, isFrontPage }) => {
  if (!contentArea) {
    return null;
  }
  
  return (
    <>
      {contentArea.expandedValue?.map((module, index) => (
        <React.Fragment key={index}>
            {mapContentToBlock(module, isFrontPage)}
        </React.Fragment>
      ))}
    </>
  );
};
